import React,{Component} from 'react';
import Chart from 'chart.js';
import moment from "moment/moment";
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import language from '../../../libraries/label-lang';
import {bindActionCreators} from 'redux';
import {RootActions} from '../../../shared/root-action';
import {connect} from 'react-redux';

class Histories extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            showDialog: false,

            currentMonth: '',
            month: null,

            currentExpenses: '',
            lastExpenses: 0,
            totalTopUp: 0,
        };
    }

    componentDidMount(){

        document.title = 'Fresh Factory - Riwayat';

        this.setState({
            month: moment().format('MM'),
        }, () => this.__fetchData());

    };

    __fetchData = () => {

        let month = moment().format('YYYY')+'-'+this.state.month+'-01';

        Api.get('/expenses/total?month='+month).then(resp => {
            if (resp.data) {

                let last = Math.abs(parseFloat(resp.data.last_month_expenses));
                let current = Math.abs(parseFloat(resp.data.current_month_expenses));

                this.setState({
                    currentExpenses: resp.data.current_month_expenses ? Math.abs(parseFloat(resp.data.current_month_expenses)) : 0,
                    lastExpenses: resp.data.last_month_expenses ? Math.abs(parseFloat(resp.data.last_month_expenses)) : 0,
                    totalFull: resp.data.total_fulfillment ? Math.abs(parseFloat(resp.data.total_fulfillment)) : 0,
                    totalItem: resp.data.total_sold_items ? Math.abs(parseFloat(resp.data.total_sold_items)) : 0,
                    totalAvg: resp.data.total_avg_stored_items ? Math.abs(parseFloat(resp.data.total_avg_stored_items)) : 0,
                    totalSales: resp.data.total_sales ? Math.abs(parseFloat(resp.data.total_sales)) : 0,
                });

                this.buildChart();
                //setTimeout( this.buildChart, 5000);
            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });

        Api.get('/wallets/total_top_up?month='+month).then(resp => {
            if (resp.data) {

                this.setState({
                    totalTopUp: parseFloat(resp.data.total_top_up),
                });

            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });


    };

    buildChart(){

        let last = this.state.lastExpenses;
        let curr = this.state.currentExpenses;
        console.log(last);
        console.log(curr);
        let data = {
            labels: ["Bulan Lalu", "Bulan Ini"],
            datasets: [{
                label: 'Biaya',
                data: [last, curr],
                backgroundColor: [
                    '#419ad2',
                    '#68cef4'
                ],
                borderWidth: 1,
                barPercentage: 0.5,
            }]
        };

        let options = {
            cornerRadius: 20,
            scales: {
                xAxes: [{
                    ticks: {
                        min: 0,
                        stepSize: 1,
                        beginAtZero:true,
                        userCallback: function(value, index, values) {
                            // Convert the number to a string and splite the string every 3 charaters from the end
                            value = value.toString();
                            value = value.split(/(?=(?:...)*$)/);

                            // Convert the array to a string and format the output
                            value = value.join('.');
                            return 'Rp ' + value;
                        }
                    },
                    gridLines: {
                        offsetGridLines: false
                    }
                }],
                yAxes: [{
                    gridLines: {
                        offsetGridLines: false
                    }
                }]
            },
            scaleLabel:
                function(label){return  '$' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");}

        };

        let ctxHBar = document.getElementById("horizontal_bar_chart");
        let myHorizBarChart = new Chart(ctxHBar, {
            type: 'horizontalBar',
            data: data,
            options: options
        });

        this.setState({
            data: data, options: options
        });
        myHorizBarChart.destroy();
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        }, () => {
            this.__fetchData();
        })

    };


    handleGo  = (link) => {
        history.push(link);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    handleSearch = () => {
        this.__fetchData(false);
    };
    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(false);
        }
    };

    handleSort = (val) => {

        let sortedBy = this.state.sortedBy;

        if(val !== this.state.orderBy){
            sortedBy = 'asc';
        }else{
            if(sortedBy && sortedBy === 'asc' ){
                sortedBy = 'desc';
            }else{
                sortedBy = 'asc';
            }
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage:newPage,
            currentPageTable:newPage,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage:parseInt(event.target.value, 10),
            currentPage:1,
            loading: true,
        },() => {
            this.__fetchData(false);
        });
    };


    render() {
        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>{text.label_history}</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>Riwayat Dompet Anda</h2>
                <div className='row'>
                    <div className='col-12'>
                        {/*<div className='card-info mb-3'>*/}
                        {/*    <i className="fas fa-info-circle"> </i>*/}
                        {/*    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>*/}
                        {/*</div>*/}
                        <div className='row align-items-center'>
                    {/*        <div className='col-6 col-md-2'>
                                <label>Tanggal</label>
                            </div>*/}
                            <div className='col-6 col-md-7'>
                                <div className='form-group'>
                                    <TextField
                                        select
                                        variant="outlined"
                                        id='month'
                                        name='month'
                                        label='Bulan'
                                        onChange={(e) => this.handleChange(e, 'month')}
                                        value={this.state.month === null ? this.state.currentMonth : this.state.month}
                                        fullWidth
                                    >
                                        <MenuItem value='01'>Januari</MenuItem>
                                        <MenuItem value='02'>Februari</MenuItem>
                                        <MenuItem value='03'>Maret</MenuItem>
                                        <MenuItem value='04'>April</MenuItem>
                                        <MenuItem value='05'>Mei</MenuItem>
                                        <MenuItem value='06'>Juni</MenuItem>
                                        <MenuItem value='07'>Juli</MenuItem>
                                        <MenuItem value='08'>Agustus</MenuItem>
                                        <MenuItem value='09'>September</MenuItem>
                                        <MenuItem value='10'>Oktober</MenuItem>
                                        <MenuItem value='11'>November</MenuItem>
                                        <MenuItem value='12'>Desember</MenuItem>
                                    </TextField>
                               </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='card-white__dash mb-3'>
                                    <div className='row'>
                                        <div className='col-6 border-right'>
                                            <h3 className='title-grey'>Fulfillment</h3>
                                            <p className='number'>{this.state.totalFull}</p>
                                        </div>
                                        <div className='col-6'>
                                            <h3 className='title-grey'>Item Terjual</h3>
                                            <p className='number'>{this.state.totalItem}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card-white__dash mb-3'>
                                    <h3 className='title-grey'>Rata-rata Item Tersimpan</h3>
                                    <p className='number'>
                                        {this.state.totalAvg}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div className='card-white__dash mb-3'>
                                    <h3 className='title-grey'>Total Top-Up</h3>
                                    <p className='number'>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.totalTopUp} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card-white__dash mb-3'>
                                    <h3 className='title-grey'>Total Biaya</h3>
                                    <p className='number'>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.currentExpenses} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card-white__dash mb-3'>
                                    <h3 className='title-grey'>Total Penjualan</h3>
                                    <p className='number'>
                                        Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.totalSales} fixedDecimalScale={false} displayType={'text'} renderText={value => value} />
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='card-white__dash mb-3'>
                            <h3>Ringkasan Biaya</h3>
                            <canvas
                                id="horizontal_bar_chart"
                            height='80px'> </canvas>
                        </div>
                        <Button
                            variant='contained'
                            color='primary'
                            className='mb-3'
                            onClick={() => this.handleGo('/histories/list')}
                        >
                            Catatan Biaya
                        </Button>
                    </div>
                </div>


                <ToastContainer />

            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Histories));